import { Range } from 'slate';
import { toggleBlock } from './utilities';

const withDeleteEmptyBlock = (editor: any) => {
  const { deleteBackward } = editor;

  editor.deleteBackward = (unit: any) => {
    const { selection } = editor;

    if (
      selection &&
      selection.focus.offset === 0 &&
      selection.anchor.offset === 0 &&
      Range.isCollapsed(selection)
    ) {
      const node = editor.children[selection.anchor.path[0]];

      if (node && node.type && node.children.length === 1) {
        toggleBlock(editor, node.type);
      }

      deleteBackward(unit);
    } else {
      deleteBackward(unit);
    }
  };

  return editor;
};

export default withDeleteEmptyBlock;
